import React, {Component} from "react";
import Form from "../../components/forms/ConfirmForm";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import { connect } from "react-redux";
import { cancelDeleteOrderTaggingRule } from "../../actions/ShippingApiActions";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

class DeleteOrderTaggingRuleFormContainer extends Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(_values) {
    return this.props.deleteShippingOrderTaggingRule({ruleId: this.props.ruleId})
      .then((response) => {
        if (response.data.deleteShippingOrderTaggingRule.errors.length <= 0) {
          this.handleCancel();
        } else {
          let errors = createValidationErrors(response.data.deleteShippingOrderTaggingRule.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });
  }

  handleCancel() {
    this.props.cancelDeleteOrderTaggingRule(this.props.ruleId);
  }

  render() {
    return (
      <Form
        message="Are you sure you want to delete this order tagging rule?"
        submitLabel="Delete"
        errors={this.state.errors}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }

}

const DELETE_ORDER_TAGGING_RULE = gql`
  mutation deleteShippingOrderTaggingRule($data: DeleteShippingOrderTaggingRuleInput!) {
    deleteShippingOrderTaggingRule(input: $data) {
      errors { key message }
    }
  }
`;

const withMutation = graphql(DELETE_ORDER_TAGGING_RULE, {
  props: ({ mutate }) => ({
    deleteShippingOrderTaggingRule: (data) => mutate({
      variables: { data: data }
    })
  })
});

export default connect(null, {cancelDeleteOrderTaggingRule})(withMutation(DeleteOrderTaggingRuleFormContainer));
